import $ from "jquery";

const faq = () => {
  $(document).ready(function () {
    $(".faq__header").click(function () {
      let $this = $(this);
      $this.next(".faq__body").slideToggle();
      $this.parent(".faq__item").toggleClass("active");
    });
  });
};

export default faq;
